import { forwardRef } from 'react';

import { getTextInputStyles } from './helpers';
import { InputController, type InputProps } from './InputController';

import { useForwardedRef } from '../../hooks/useForwardedRef';
import { classNames } from '../../server/utils/classNames';

export type TextInputFieldProps = Omit<InputProps<HTMLInputElement>, 'type'> & {
	type?: Exclude<InputProps<HTMLInputElement>['type'], 'search'>;
};

export const TextInputField = forwardRef<HTMLInputElement, TextInputFieldProps>(
	({ className, endAdornment, hint, invalid, error, label, ...rest }, ref) => {
		const forwardedRef = useForwardedRef(ref);

		const inputClasses = classNames(getTextInputStyles(!!invalid, rest.disabled), className);

		return (
			<InputController
				endAdornment={endAdornment}
				forwardedRef={forwardedRef}
				containerClassName="h-16"
				getEyelidClassName={shouldRaiseEyelid =>
					classNames({
						'top-0 pt-3': shouldRaiseEyelid,
						'top-1/2 -translate-y-1/2': !shouldRaiseEyelid,
					})
				}
				hint={hint}
				invalid={invalid}
				error={error}
				label={label}
				{...rest}
				render={({ handleBlur, handleChange, handleFocus, handleOnInputChange, ...inputProps }) => {
					return (
						<input
							{...inputProps}
							className={inputClasses}
							onBlur={handleBlur}
							onChange={handleChange}
							onFocus={handleFocus}
							onInput={handleOnInputChange}
							ref={forwardedRef}
						/>
					);
				}}
			/>
		);
	},
);
